import { render, staticRenderFns } from "./session_sidebar.vue?vue&type=template&id=10e8fd17&"
import script from "./session_sidebar.vue?vue&type=script&lang=js&"
export * from "./session_sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10e8fd17')) {
      api.createRecord('10e8fd17', component.options)
    } else {
      api.reload('10e8fd17', component.options)
    }
    module.hot.accept("./session_sidebar.vue?vue&type=template&id=10e8fd17&", function () {
      api.rerender('10e8fd17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/sessions/session_sidebar.vue"
export default component.exports